import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

/** GET /wishlist — Returns WishlistSummaryDto (stats + all items) */
export const getWishlistSummary = async () => {
  const response = await axiosInstance.get('/wishlist');
  return response.data;
};

// Keep old name as alias for Redux slice compatibility
export const getWishlistItems = getWishlistSummary;

/** GET /wishlist/statistics — Lightweight stats only */
export const getWishlistStatistics = async () => {
  const response = await axiosInstance.get('/wishlist/statistics');
  return response.data;
};

/** GET /wishlist/by-supplier/{supplierId} */
export const getWishlistBySupplier = async (supplierId) => {
  const response = await axiosInstance.get(`/wishlist/by-supplier/${supplierId}`);
  return response.data;
};

/** GET /wishlist/by-priority/{priority} — priority: High | Medium | Low */
export const getWishlistByPriority = async (priority) => {
  const response = await axiosInstance.get(`/wishlist/by-priority/${priority}`);
  return response.data;
};

/** GET /wishlist/{id} */
export const getWishlistItemById = async (id) => {
  const response = await axiosInstance.get(`/wishlist/${id}`);
  return response.data;
};

/** POST /wishlist — WishlistDto: { ProductId, Quantity, Priority, Notes, SupplierId } */
export const addToWishlist = async (dto) => {
  const response = await axiosInstance.post('/wishlist', dto);
  return response.data;
};

/** PUT /wishlist — WishlistDto with Id field set */
export const updateWishlistItem = async (dto) => {
  const response = await axiosInstance.put('/wishlist', dto);
  return response.data;
};

/** DELETE /wishlist/{id} */
export const removeFromWishlist = async (id) => {
  const response = await axiosInstance.delete(`/wishlist/${id}`);
  return response.data;
};

/** POST /wishlist/bulk-delete — body: number[] */
export const bulkDeleteWishlistItems = async (ids) => {
  const response = await axiosInstance.post('/wishlist/bulk-delete', ids);
  return response.data;
};

/** POST /wishlist/bulk-update-priority — WishlistBulkActionDto */
export const bulkUpdatePriority = async (action) => {
  const response = await axiosInstance.post('/wishlist/bulk-update-priority', action);
  return response.data;
};